<template>
  <v-card flat :style="cssTheme">
    <v-card flat v-if="breakpoint !== 'lg' && breakpoint !== 'xl'">
      <!-- Header -->
      <v-container class="header-tile" v-if="dataCache.length > 0">
        <v-row>
          <v-col :cols="5" class="py-0 pl-0">
            <span class="pl-3" style="color:#9E9E9E; font-size:14px;">{{
              headersInMobile[0].text
            }}</span>
          </v-col>
          <v-col :cols="3" class="py-0 pr-0 pl-2" offset="1">
            <span style="color:#9E9E9E; font-size:14px;">{{
              headersInMobile[1].text
            }}</span>
          </v-col>
          <v-spacer></v-spacer>
          <v-col
            cols="auto"
            class="py-0 pr-0"
            v-if="Object.keys(subtile).length > attributes.length"
          >
            <span class="pr-3" style="color:#9E9E9E; font-size:14px;"
              >More</span
            >
          </v-col>
        </v-row>
      </v-container>
      <!-- List Data -->
      <v-card flat v-if="breakpoint !== 'lg' && breakpoint !== 'xl'">
        <v-list class="pt-0 pb-1" flat>
          <v-list-group
            v-for="(item, index) in dataCache"
            :key="index"
            :class="index === curIndex ? 'list_group_active' : ''"
            :style="index % 2 === 0 ? '' : 'background: #f7f7f7;'"
            :ripple="false"
            @click="clickedItem(index)"
            append-icon
          >
            <template v-slot:activator>
              <v-container>
                <v-row>
                  <v-col :cols="5" class="px-0 py-0" align-self="center">
                    <div class="link_style">
                      <a
                        @click="
                          redirect(
                            dataCache[index][attributes[0].value],
                            links[attributes[0].value],
                            $event
                          )
                        "
                        :href="
                          getHref(
                            dataCache[index][attributes[0].value],
                            links[attributes[0].value]
                          )
                        "
                      >
                        <div
                          v-if="attributes[0].value === 'address'"
                          v-ellipsis.middle
                          style="width: inherit;"
                        >
                          {{ dataCache[index][attributes[0].value] }}
                        </div>
                        <span v-else>
                          {{ dataCache[index][attributes[0].value] }}
                        </span>
                      </a>
                    </div>
                    <div
                      class="list_subtile"
                      v-if="attributes[0].value !== 'address'"
                    >
                      <timeago
                        v-if="
                          subtile[subtile[attributes[0].value].property][
                            'type'
                          ] === 'time_ago' &&
                            dataCache[index][
                              subtile[attributes[0].value].property
                            ] !== '-'
                        "
                        :datetime="
                          dataCache[index][
                            subtile[attributes[0].value].property
                          ]
                        "
                        :auto-update="60"
                        style="white-space: normal;"
                      ></timeago>
                      <span v-else style="white-space: normal;">
                        {{
                          dataCache[index][
                            subtile[attributes[0].value].property
                          ]
                        }}</span
                      >
                    </div>
                  </v-col>
                  <v-col
                    :cols="
                      Object.keys(subtile).length > attributes.length ? 5 : 6
                    "
                    :offset="1"
                    class="pl-2 pr-0 py-0"
                    align-self="center"
                    style="color: #444444;"
                  >
                    <marquee-text
                      v-if="isSeletedMarqueeText && curIndex === index"
                      :repeat="10"
                    >
                      <span
                        v-if="
                          subtile[attributes[1].value]['type'] ===
                            'income_outcome' ||
                            subtile[attributes[1].value]['type'] === 'status'
                        "
                        :class="
                          getlistFontColor(
                            dataCache[index][attributes[1].value],
                            subtile[attributes[1].value]['type']
                          )
                        "
                      >
                        {{
                          dataCache[index][attributes[1].value] +
                            "&nbsp;&nbsp;&nbsp;&nbsp;"
                        }}
                      </span>
                      <span v-else>
                        {{
                          dataCache[index][attributes[1].value] +
                            "&nbsp;&nbsp;&nbsp;&nbsp;"
                        }}
                      </span>
                    </marquee-text>
                    <div v-else class="list_tile" :ref="index + 'amount'">
                      <span
                        :ref="index + 'amountText'"
                        v-if="
                          subtile[attributes[1].value]['type'] ===
                            'income_outcome' ||
                            subtile[attributes[1].value]['type'] === 'status'
                        "
                        :class="
                          getlistFontColor(
                            dataCache[index][attributes[1].value],
                            subtile[attributes[1].value]['type']
                          )
                        "
                      >
                        {{ dataCache[index][attributes[1].value] }}
                      </span>
                      <span :ref="index + 'amountText'" v-else>
                        {{ dataCache[index][attributes[1].value] }}
                      </span>
                    </div>
                  </v-col>
                  <v-col :cols="1" class="px-0 py-0" align-self="center">
                    <div
                      align="right"
                      style="margin-top:3px;"
                      v-if="Object.keys(subtile).length > attributes.length"
                    >
                      <v-icon
                        :class="curIndex === index ? 'chevrondown' : ''"
                        dense
                        >mdi-chevron-down</v-icon
                      >
                    </div>
                  </v-col>
                </v-row>
              </v-container>
            </template>
            <v-container class="py-0">
              <v-row v-if="Object.keys(subtile).length > attributes.length">
                <v-col
                  :cols="5"
                  align-self="end"
                  v-for="(subAttr, subIndex) in order"
                  :key="subIndex"
                  :offset="subIndex % 2"
                  class="pt-1 pb-3 pr-0"
                  style="color: #444444;"
                >
                  <!-- tile -->
                  <div class="link_style" v-if="links[subAttr]">
                    <a
                      @click="
                        redirect(
                          dataCache[index][subAttr],
                          links[subAttr],
                          $event
                        )
                      "
                      :href="getHref(dataCache[index][subAttr], links[subAttr])"
                    >
                      <div
                        v-ellipsis.middle
                        :style="'width:' + colWidth + 'px;'"
                      >
                        {{ dataCache[index][subAttr] }}
                      </div>
                    </a>
                  </div>
                  <div
                    v-else-if="
                      subtile[subAttr]['type'] === 'time_ago' &&
                        dataCache[index][subAttr] !== '-'
                    "
                    style="width:140px;"
                  >
                    <timeago
                      :datetime="dataCache[index][subAttr]"
                      :auto-update="60"
                    ></timeago>
                  </div>
                  <div
                    :class="
                      getlistFontColor(
                        dataCache[index][subAttr],
                        subtile[subAttr]['type']
                      )
                    "
                    v-else-if="
                      subtile[subAttr]['type'] === 'status' &&
                        dataCache[index][subAttr] !== '-'
                    "
                  >
                    {{ dataCache[index][subAttr] }}
                  </div>
                  <div style="color: #444444;" v-else>
                    {{ dataCache[index][subAttr] }}
                  </div>
                  <!-- subtile -->
                  <div class="list_subtile">
                    {{ subtile[subAttr].text }}
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </v-list-group>
        </v-list>
      </v-card>
    </v-card>
    <v-card
      flat
      scrollable
      :style="getHoverColor"
      v-if="breakpoint === 'lg' || breakpoint === 'xl'"
    >
      <v-data-table
        :headers="headers"
        :items="dataCache"
        :items-per-page="tableDataPreNum"
        :loading="isLoadingMore"
        :disable-sort="true"
        :hide-default-footer="true"
        :hide-default-header="true"
        class="hidden-md-and-down mb-5"
      >
        <template v-slot:header="{ props: { headers } }">
          <thead>
            <tr class="header-tile">
              <th
                v-for="(header, index) in headers"
                :key="index"
                :style="'border-bottom: none; text-align:' + header.align + ';'"
                :class="
                  !subtile[header.value]['computerHidden']
                    ? ''
                    : 'hidden-lg-and-up'
                "
              >
                {{ header.text }}
              </th>
            </tr>
          </thead>
        </template>
        <!-- :class="index % 2 === 0 ? '' : 'tile'" -->
        <template v-slot:body="{ items, headers }">
          <tbody>
            <tr
              v-for="(item, index) in items"
              :key="index"
              :class="index % 2 === 0 ? 'white-row' : 'tile'"
            >
              <td
                v-for="(val, key) in item"
                :key="key"
                style="border-bottom: none;"
                :align="headers[headersIndex[key]].align"
                :class="
                  !subtile[key]['computerHidden'] ? '' : 'hidden-lg-and-up'
                "
              >
                <div
                  class="link_style"
                  :style="tableCellMaxWidth[breakpoint]"
                  v-if="links[key] && val !== '-'"
                >
                  <a
                    :href="getHref(val, links[key])"
                    @click="redirect(val, links[key], $event)"
                    style="text-decoration:none;"
                    >{{ cropStrMiddle(val, key) }}</a
                  >
                </div>
                <span
                  v-else-if="
                    subtile[key]['type'] === 'income_outcome' ||
                      subtile[key]['type'] === 'status'
                  "
                  :class="getlistFontColor(val, subtile[key]['type'])"
                  >{{ val }}</span
                >
                <timeago
                  v-else-if="subtile[key]['type'] === 'time_ago' && val !== '-'"
                  :datetime="val"
                  :auto-update="60"
                  style="white-space: nowrap;"
                ></timeago>
                <span v-else style="white-space: nowrap;">{{ val }}</span>
              </td>
            </tr>
          </tbody>
        </template>
      </v-data-table>
    </v-card>
    <v-card
      flat
      v-if="(!isLoadingMore && dataCache.length === 0) || showError"
      class="d-flex justify-center"
    >
      <span>{{ this.notification }}</span>
    </v-card>
    <v-card flat v-if="isLoadingMore" class="d-flex justify-center">
      <v-progress-circular
        :size="30"
        :width="3"
        color="primary"
        indeterminate
        class="py-12 pb-5"
      />
    </v-card>
    <v-card flat v-else-if="hasMoreData && !hasBoundry && !infiniteLoading">
      <v-btn
        color="primary"
        block
        text
        class="original-text-button"
        @click="loadMoreData()"
      >
        <span>{{ btnMsg }}</span>
        <v-icon v-if="dataCache && dataCache.length > 0"
          >mdi-chevron-double-down</v-icon
        >
      </v-btn>
    </v-card>
    <v-card flat v-else height="30px"></v-card>
  </v-card>
</template>
<script>
import Vue from "vue";
import { mapState, mapMutations } from "vuex";
import MarqueeText from "vue-marquee-text-component";
import Big from "big.js";
export default {
  components: {
    MarqueeText
  },
  props: {
    links: {
      type: Object,
      default: () => ({})
    },
    apiUrl: {
      type: String,
      default: () => ""
    },
    attributes: {
      type: Array,
      default: () => []
    },
    propLimit: {
      type: Number,
      default: () => 10
    },
    order: {
      type: Array,
      default: () => []
    },
    subtile: {
      type: Object,
      default: () => ({})
    },
    params: {
      type: Object,
      default: () => ({})
    },
    hasBoundry: {
      type: Boolean,
      default: false
    },
    infiniteLoading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isLoading: true,
      isLoadingMore: false,
      limit: 0,
      startIndex: null,
      dataCache: [],
      tableData: [],
      headersInMobile: [],
      headers: [],
      expanded: [],
      tableDataPreNum: 10,
      options: {},
      hasMoreData: true,
      dataType: "all",
      httpReqLimit: 3,
      notification: "no data",
      showError: false,
      btnMsg: "More Information",
      hoverColor: {
        red: "rgba(255, 84, 106, 0.15)",
        yellow: "rgba(255, 161, 0, 0.15)",
        purple: "rgba(130, 65, 249, 0.15)",
        blue: "rgba(6, 142, 241, 0.15)",
        cyan: "rgba(0, 184, 175, 0.15)"
      },
      tableCellMaxWidth: {
        xs: "",
        sm: "",
        md: "",
        lg: "max-width:250px",
        xl: "auto"
      },
      isMarqueeTextItems: [],
      breakpoint: this.$vuetify.breakpoint.name,
      addressTailReserved: 6,
      container: document.documentElement,
      domHeight: document.documentElement.clientHeight,
      mobileWidthLimit: 375,
      isSeletedMarqueeText: false,
      selectedIndex: -1,
      curIndex: -1,
      colWidth: 0,
      headersIndex: {}
    };
  },
  computed: {
    ...mapState(["tokenInfo", "toLoadMore", "hasMore", "theme"]),
    cssTheme() {
      return {
        "--active-theme": this.$vuetify.theme.themes.light.primary
      };
    },
    getHoverColor() {
      return this.theme
        ? {
            "--hover-color": this.hoverColor[this.theme]
          }
        : {
            "--hover-color": this.hoverColor.cyan
          };
    }
  },
  watch: {
    async toLoadMore(val) {
      if (val && this.infiniteLoading) {
        await this.loadMoreData();
        this.updateToLoadMore(false);
      }
    }
  },
  mounted() {
    let resizeId;
    window.addEventListener("resize", () => {
      clearTimeout(resizeId);
      resizeId = setTimeout(() => {
        this.breakpoint = this.$vuetify.breakpoint.name;
        this.curIndex = -1;
      }, 500);
    });
  },
  beforeDestroy() {
    let resizeId;
    window.removeEventListener("resize", () => {
      clearTimeout(resizeId);
      resizeId = setTimeout(() => {
        this.breakpoint = this.$vuetify.breakpoint.name;
        this.curIndex = -1;
      }, 500);
    });
  },
  async created() {
    this.updateHasMore(false);
    this.updateToLoadMore(false);
    this.btnMsg = this.getBtnMsg();
    this.headersInMobile = this.attributes.map(item => {
      return item;
    });
    this.headersInMobile.push({ text: "More", value: "more" });
    this.limit = this.propLimit;
    await this.loadMoreData();
  },

  methods: {
    ...mapMutations([
      "updateTokenInfo",
      "updateReloadPage",
      "updateToLoadMore",
      "updateHasMore",
      "updateLoadingData"
    ]),
    getStrHead(str) {
      return str.substring(0, str.length - this.addressTailReserved);
    },
    getStrTail(str) {
      return str.substring(str.length - this.addressTailReserved, str.length);
    },
    cropStrMiddle(id, key) {
      if (
        this.$vuetify.breakpoint.name === "xl" ||
        (this.$vuetify.breakpoint.name === "lg" && key === "address") ||
        key === "transactionId"
      ) {
        return id;
      }
      const strLen = id.length;
      const bitsReserve = strLen <= 12 ? strLen / 3 : 6;
      return (
        id.substring(0, bitsReserve) +
        "..." +
        id.substring(strLen - bitsReserve, strLen)
      );
    },
    clickedItem(index) {
      this.curIndex = this.curIndex === index ? -1 : index;
      if (this.curIndex === index) {
        this.isSeletedMarqueeText = this.checkMarqueeText(index);
      } else {
        this.isSeletedMarqueeText = false;
      }
    },
    checkMarqueeText(index) {
      // after list group has been clicked, component rerender
      let elementListTile = this.$refs[String(index) + "amount"][0];
      let elementSpan = this.$refs[String(index) + "amountText"][0];
      if (!elementListTile || !elementSpan) {
        return false;
      }
      this.colWidth = elementListTile.offsetWidth + 7;
      return elementSpan.offsetWidth >= elementListTile.clientWidth;
    },
    bigDivision(arg1, arg2) {
      arg1 = arg1 === "-" ? 0 : arg1;
      Big.NE = -(String(this.tokenInfo.unity).length + 1);
      const dividend = new Big(arg1);
      const dividor = new Big(arg2);
      let result = dividend.div(dividor);
      return result.toString();
    },
    getlistFontColor(str, type) {
      if (type === "transform_unity" || !str || str === "-") {
        return "";
      }
      if (str.startsWith("(self)")) {
        return "self_send_font_color";
      } else if (str.charAt(0) === "-") {
        return "outcome_font_color";
      } else if (str.charAt(0) === "+") {
        return "income_font_color";
      } else if (str === "Success") {
        return "income_font_color";
      }
      return "outcome_font_color";
    },
    iconRotation(active) {
      if (active) {
        return "chevrondown";
      }
      return "";
    },
    async loadMoreData() {
      this.btnMsg = this.getBtnMsg();
      this.isLoadingMore = true;
      this.updateLoadingData(true);
      const that = this;
      setTimeout(async () => {
        let apiParams = Object.assign(that.params, {
          limit: that.limit
        });

        if (that.startIndex) {
          apiParams.startIndex = that.startIndex;
        }
        try {
          await that.getRemoteData(apiParams);
        } catch (e) {
          // Ignore malformed lines
        }
        this.updateLoadingData(false);
        that.isLoadingMore = false;
      }, 500);
    },
    getBtnMsg() {
      const pageName = this.$router.currentRoute.name;
      return pageName === "address" ? "More Addresses" : "More Transactions";
    },
    redirect(id, urlPath, e) {
      e.preventDefault();
      // repalce :address/ or :transactionId/ with id
      const page = urlPath.substring(0, urlPath.indexOf("/:"));
      const route = page + "/" + id;
      const curUrl = this.$router.currentRoute.fullPath;
      //reload page
      this.updateReloadPage(true);
      if (curUrl.length !== route.length) {
        this.$router.push({
          path: route
        });
      } else if (route !== curUrl) {
        this.updateReloadPage(true);
        this.$emit("listenChild", {
          goal: "UpdateExpandTable",
          data: { address: id }
        });
        //replace url cannot result in component rerendering
        this.$router.replace({
          path: route
        });
      } else {
        const that = this;
        setTimeout(() => {
          that.updateReloadPage(false);
        }, 500);
      }
    },

    getHref(id, urlPath) {
      const page = urlPath.substring(0, urlPath.indexOf("/:"));
      const route = page + "/" + id;
      return route;
    },
    // load more btn invoke this function from parent component
    async searchByType(type) {
      this.dataCache = [];
      this.isLoadingMore = true;
      let apiParams = Object.assign(this.params, {
        limit: this.limit
      });
      if (this.startIndex) {
        apiParams.startIndex = this.startIndex;
      }

      if (type != "all") {
        apiParams.functionIndexType = type;
      } else {
        delete apiParams.functionIndexType;
      }
      this.dataType = type;
      try {
        await this.getRemoteData(apiParams);
      } catch (e) {
        // Ignore malformed lines
      }

      this.isLoadingMore = false;
    },
    updateHeaders() {
      this.headers = [];
      let headerIndex = 0;
      // const alignments = ["left", "center", "right"];
      let align = null;
      for (let prop in this.subtile) {
        if (this.subtile.hasOwnProperty(prop)) {
          align = !align ? "left" : "right";
          const text = this.subtile[prop].text;
          const element = {
            text: text,
            value: prop,
            align
          };
          Vue.set(this.headers, headerIndex, element);
          this.headersIndex[prop] = headerIndex;
          headerIndex++;
        }
      }
    },
    formatLocalTime(timestamp) {
      if (!timestamp || timestamp === "-") {
        return "-";
      }
      const formatedTime = this.cutTimeStamp(timestamp);
      const date = new Date(formatedTime);
      const year = date.getFullYear();
      const MM =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1;
      const dd = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      const hh = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
      const mm =
        date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      const ss =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      return `${year}-${MM}-${dd} ${hh}:${mm}:${ss}`;
    },
    cutTimeStamp(timestamp) {
      if (!timestamp) {
        return "-";
      }
      const timestampStr = timestamp.toString();
      const timestampLen = timestampStr.length;
      if (timestampLen > 13) {
        const lengthDiff = timestampLen - 13;
        const divider = Math.pow(10, lengthDiff);
        timestamp = Math.round(timestamp / divider);
      }
      return timestamp;
    },
    shortTimeStr(timestamp) {
      const formatedTime = this.cutTimeStamp(timestamp);
      const date = new Date(formatedTime);
      const year = date.getFullYear();
      const MM =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1;
      const dd = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      const hh = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
      const mm =
        date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      return `${year}.${MM}.${dd} ${hh}:${mm}`;
    },
    updateDataCache(data) {
      try {
        if (data && data.length > 0) {
          let tempList = [];
          data.forEach(item => {
            let subItem = {};
            for (let prop in this.subtile) {
              if (this.subtile.hasOwnProperty(prop)) {
                subItem[prop] = "-";
                if (
                  item[prop] ||
                  item[prop] === "0" ||
                  typeof item[prop] === "boolean"
                ) {
                  subItem[prop] = item[prop];
                } else if (
                  item["content"] &&
                  item["content"]["data"] &&
                  (item["content"]["data"][prop] ||
                    item["content"]["data"][prop] === "0" ||
                    typeof item["content"]["data"][prop] === "boolean")
                ) {
                  subItem[prop] = item["content"]["data"][prop];
                }
                subItem[prop] = this.reformByType(
                  this.subtile[prop]["type"],
                  subItem[prop],
                  item
                );
              }
            }

            tempList.push(subItem);
            this.isMarqueeTextItems.push(false);
          });
          this.dataCache = this.dataCache.concat(tempList);
          this.tableDataPreNum = this.dataCache.length;
          if (this.headers && this.headers.length === 0) {
            this.updateHeaders();
          }
        }
      } catch (e) {
        // Ignore malformed lines
      }
    },
    reformByType(type, value, item) {
      if (!type || !value) {
        return value;
      }
      switch (type) {
        case "timestamp":
          return document.documentElement.clientWidth < this.mobileWidthLimit
            ? this.shortTimeStr(value)
            : this.formatLocalTime(value);
        case "transform_unity":
          return this.thousandsformat(
            this.bigDivision(value, this.tokenInfo.unity)
          );
        case "time_ago":
          return this.cutTimeStamp(value);
        case "income_outcome":
          return this.incomeOrOutcome(
            item,
            this.bigDivision(value, this.tokenInfo.unity)
          );
        case "thousands":
          return this.thousandsformat(value);
        case "status":
          return value === "Success" ? "Success" : "Failed";
        default: {
          return value;
        }
      }
    },
    async getRemoteData(params) {
      let count = 0;
      let reqTime = 0;
      this.showError = false;
      let errorMsg = "Please check internet connection.";
      try {
        //result.length === 0 deal with first query which startIndex is null
        while (
          count < this.limit &&
          (Boolean(this.startIndex) || this.dataCache.length === 0) &&
          reqTime <= this.httpReqLimit
        ) {
          const res = await this.$http.get(this.apiUrl, {
            params
          });
          reqTime++;
          if (
            res &&
            res.data &&
            res.data.result.Items &&
            res.data.result.Items.length > 0
          ) {
            count = count + res.data.result.Items.length;
            this.startIndex = res.data.result.LastEvaluatedKey;
            // improve query range if limit is greater than res data. in another words, limit is the range of data to query
            params.limit = this.limit - count;
            if (this.startIndex) {
              params.startIndex = this.startIndex;
            }
            this.updateDataCache(res.data.result.Items);
          } else if (reqTime === this.httpReqLimit && count === 0) {
            errorMsg =
              res &&
              res.data &&
              res.data.result.Items &&
              res.data.result.Items.length === 0
                ? "No latest data."
                : errorMsg;
            throw new Error("Error: No matching data.");
          }
        }
      } catch (e) {
        this.showError = true;
        if (e.response && e.response.status && e.response.status === 404) {
          errorMsg = "Token does not contain related data";
        } else if (e.code === "ECONNABORTED") {
          this.btnMsg = "Reload";
          errorMsg =
            "Time out! Please check Internet connection or try again later.";
        } else if (e.message === "Network Error") {
          this.btnMsg = "Reload";
          errorMsg = "Network Error!  Please check internet connection.";
        }
        this.notification = errorMsg;
      }
      this.hasMoreData = Boolean(this.startIndex);
      this.updateHasMore(this.hasMoreData);
    },
    isNumeric(n) {
      return typeof n !== "boolean" && !isNaN(n);
    },
    thousandsformat(t) {
      if (t === "-") {
        return 0;
      }
      if (!this.isNumeric(t)) {
        throw new Error("Error: Cannot convert nonnumeric data to thousands.");
      }
      const numStr = String(t);
      const numStrLen = numStr.length;
      const pointIndex =
        numStr.indexOf(".") > 0 ? numStr.indexOf(".") : numStrLen;

      let result = numStr
        .substring(0, pointIndex)
        .replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, "$&,");
      if (pointIndex > 0 && pointIndex < numStrLen) {
        result = result + numStr.substring(pointIndex, numStrLen);
      }
      return result;
    },
    incomeOrOutcome(txObj, amount) {
      const sender = txObj.signer;
      const recipient = txObj.recipient;
      const address =
        this.$router.currentRoute.name === "addressDetail"
          ? this.$router.currentRoute.params.address
          : null;
      amount = this.thousandsformat(amount);
      if (!address) {
        return amount;
      }
      if (sender === recipient && sender === address) {
        return "(self)" + String(amount);
      }
      return sender === address ? "-" + String(amount) : "+" + String(amount);
    },
    sortByAddr(list) {
      return list.sort((a, b) => {
        return a.address.localeCompare(b.address);
      });
    }
  }
};
</script>
<style>
.mobile_link_style {
  color: var(--active-theme) !important;
  text-decoration: none;
}
.link_style {
  color: var(--active-theme) !important;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.list_tile {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.link_style a {
  text-decoration: none;
}
.list_group_active {
  outline: 1px solid var(--active-theme);
}
.list_subtile {
  color: #9e9e9e;
  font-size: 12px;
  height: 14px;
  font-weight: 300;
  width: 140px;
}
div.btn__content {
  padding: 0;
}
.chevrondown {
  transition: 0.3s all cubic-bezier(1, 0.25, 0.25, 0.8);
  will-change: transform;
  transform: rotate(180deg);
}
</style>
<style scoped>
.v-data-table th {
  font-size: 12px;
}
.header-tile {
  background: #f7f7f7;
}
.tile {
  background: #f7f7f7;
}
.tile:hover {
  background: var(--hover-color) !important;
}
.white-row {
  background: #ffffff;
}
.white-row:hover {
  background: var(--hover-color) !important;
}
.list_item {
  background: #ffffff;
}
.v-list-item__subtile_small {
  white-space: normal;
}
.income_font_color {
  color: #009e73;
}
.outcome_font_color {
  color: #d94040;
}
.self_send_font_color {
  color: #ffb74d;
}
</style>
